<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加渠道信息</el-button
    >

    <el-dialog
      title="添加渠道信息"
      width="600px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
       :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户Id" prop="channelUserId">
          <el-input
            v-model.trim="ruleForm.channelUserId"
            placeholder="请输入用户Id"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道来源" prop="note">
          <el-input
            v-model.trim="ruleForm.note"
            placeholder="请输入渠道信息"
          ></el-input>
        </el-form-item>
         <el-form-item label="渠道编码" prop="channelCode">
          <el-input
            v-model.trim="ruleForm.channelCode"
            placeholder="请输入渠道编码"
          ></el-input>
        </el-form-item>
        <!--<el-form-item label="理财线路名称" prop="financialUrl">
          <el-input
            v-model.trim="ruleForm.financialUrl"
            placeholder="请输入域名或地址 如 https://www.financial.com"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="国家区号" prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            placeholder="请输入国家区号，例如中国为86"
          ></el-input>
        </el-form-item>
        <el-form-item label="国家码" prop="locale">
          <el-input
            v-model.trim="ruleForm.locale"
            placeholder="例如中国为CHN"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="启用状态" prop="status">
         
          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item> -->

        <el-form-item label-width="200px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定添加</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {ValidateCode,ValidateEN,ValidateLocale,ValidateZH,ValidateLineUrl } from '../../validate.js'

export default {
  data() {
    
    return {
      dialogVisible: false,
      ruleForm: {
        channelUserId:'',
        note:''
      },
      arr: [],
      result: false,
      rules: {
        channelUserId: [
          {
            required: true,
            message: "请输入邀请人用户Id",
            trigger: "blur",
          },
          // { message: "请输入线路名称", trigger: "blur" },
        ],
        note: [
          { required: true, message: "请输入渠道信息", trigger: "blur" },
        ],
        channelCode: [
          { required: true, message: "请输入渠道编码", trigger: "blur" },
        ],
       
      lineUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
          
        ],
        financialUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
          
        ],
      },
    };
  },
  mounted() {
    // this.ruleForm = {
    //   zh: "",
    //   lineUrl:'',
    //   en: "",
    //   status: 0,
    // };
  },
  methods: {
    ...mapActions("channel", ["addOne", "getlist","getUrlList"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    closeDialog() {},
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
     submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if(valid){
      const obj={...this.ruleForm,channelUserId:Number(this.ruleForm.channelUserId)}
        // this.$refs[formName].validate(async (val) => {
         const res=await this.addOne(obj)
         if(res.code==0){
           this.dialogVisible = false;
           this.getUrlList({page:1,size:10,channelCode:''})
           this.resetForm()
            this.$message.success("添加成功");
         }else{
        this.$message.error("添加失败，请重试");
         }
        }
      })

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
